'use client'

import { SpeelMee } from "./speel-mee"
import { useCompetitionContext } from "../providers/CompetitionContext";

export function Tutorial() {
  const { brand } = useCompetitionContext();
  return (
    // <section className="mb-8 overflow-hidden rounded-lg bg-[#1F2544] rounded-b-lg shadow">
      <div className="container max-w-[1140px] mx-auto min-h-full ">
        <h2 className="text-xl md:text-2xl text-center p-4">Hoe werkt het Klassiekerspel?</h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 m-4">
          <div className="bg-white overflow-hidden md:col-span-2">
            <div className="p-2 h-48 flex items-center justify-center relative">
                <img 
                  src='https://dpgnl.s3.eu-west-1.amazonaws.com/files/klas-wat-is-klassiekersspel.jpg' 
                  alt="" 
                  className="w-full h-full object-contain" 
                />
            </div>
            <div className="p-2">
              <h3 className="text-[#1F2544] text-xl font-bold mb-3">
                Wat is het Klassiekerspel?
              </h3>
              <p className="text-[#1F2544] text-md">
                Het Klassiekerspel is het spel voor wielerfans waarin je met een fictief budget van 100 miljoen euro een team samenstelt en punten scoort op basis van de echte prestaties in de Klassiekers.
              </p>
              <p className="my-4"><a href="/rules" className={`text-${brand}-header`}>Bekijk de spelregels</a></p>
            </div>
          </div>

          <div className="bg-white overflow-hidden md:col-span-1">
            <div className="p-2 h-48 flex items-center justify-center relative">
                <img 
                  src='https://dpgnl.s3.eu-west-1.amazonaws.com/files/klas-prijzen.jpg' 
                  alt="" 
                  className="w-full h-full object-contain" 
                />
            </div>
            <div className="p-2">
              <h3 className="text-[#1F2544] text-xl font-bold mb-3">
                Win prachtige prijzen
              </h3>
              <p className="text-[#1F2544] text-md">
                Onze partner 12GO Biking stelt prachtige prijzen ter beschikking: een fiets naar keuze, een sporthorloge, een fietsendrager, waardebonnen en nog veel meer.
              </p>
              <p className="my-4"><a href="/prizes" className={`text-${brand}-header`}>Bekijk de prijzen</a></p>
            </div>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 m-4">
          <div className="bg-white overflow-hidden md:col-span-1">
            <div className={`p-2 h-48 flex items-center justify-center relative`}>
              <img src='https://dpgnl.s3.eu-west-1.amazonaws.com/files/klas-in-het-wiel.jpg' alt="" className="w-full h-full object-contain" />
            </div>
            <div className="p-2">
              <h3 className="text-[#1F2544] text-xl font-bold mb-3">In Het Wiel</h3>
              <p className="text-[#1F2544] text-md">Beluister onze podcast In Het Wiel voor de actuele tips voor elke koers. </p>
              <p className="my-4"><a href="/prizes" className={`text-${brand}-header`}>Bekijk de prijzen</a></p>
            </div>
          </div>

          <div className="bg-white overflow-hidden md:col-span-2">
            <div className={`p-2 h-48 flex items-center justify-center relative`}>
              <img src='https://dpgnl.s3.eu-west-1.amazonaws.com/files/klas-speel-met-vrienden.jpg' alt="" className="w-full h-full object-cover" />
            </div>
            <div className="p-2">
              <h3 className="text-[#1F2544] text-xl font-bold mb-3">Speel met vrienden</h3>
              <p className="text-[#1F2544] text-md">Maak het spel nog leuker door een vriendenleague aan te maken met collega's, familie en/of vrienden en verdien eeuwige roem!</p>
              <p className="my-4"><a href="/rules" className={`text-${brand}-header`}>Bekijk de spelregels</a></p>
            </div>
          </div>
        </div>

        <div className="p-6 text-center"><SpeelMee /></div>
      </div>
  )
}

